import { Avatar } from '@/components/Avatar/Avatar'
import { Button } from '@/components/Button/Button'
import { Dropdown } from '@/components/Select/Dropdown'
import ChevronDownSvg from '@/icons/chevron-down.svg?react'
import { useAuthState } from '@/state/auth'
import { useUserState } from '@/state/user'
import { changeRepos } from '@/utils/repos'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

enum Actions {
  ChangeRepos,
  Logout,
}

export const UserMenu: FunctionalComponent<{
  username: string
  avatarUrl?: string | null
}> = props => {
  const user = useUserState(s => s.user)
  const logout = useAuthState(s => s.logout)

  return (
    <Dropdown
      offset={8}
      width={200}
      placement='bottom-end'
      onChange={action => {
        if (action === Actions.ChangeRepos) {
          if (!user) return
          changeRepos(user.githubId)
        }
        else if (action === Actions.Logout) {
          logout()
        }
      }}
      options={[{
        label: 'Change repos',
        value: Actions.ChangeRepos,
      }, {
        label: 'Logout',
        value: Actions.Logout,
      }]}
    >
      {({ isOpen, triggerProps, setRef }) => (
        <Button
          size='s'
          {...triggerProps()}
          ref={setRef}
        >
          <Avatar
            size={16}
            src={props.avatarUrl}
          />
          <span class={styles.username}>
            {props.username}
          </span>
          <ChevronDownSvg
            class={classNames(styles.toggler, {
              [styles.active]: isOpen,
            })}
          />
        </Button>
      )}
    </Dropdown>
  )
}
